import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormGroup, FormBuilder, Validators, FormArray} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {CreateFieldDialogComponent} from '../../create-field-dialog/create-field-dialog.component';
import {ResumeService} from '../../../../services/resume.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-resumes-editor',
  templateUrl: './resumes-editor.component.html',
  styleUrls: ['./resumes-editor.component.scss']
})
export class ResumesEditorComponent implements OnInit {
  dynamicForm: FormGroup;
  pageWidth: number;
  pageHeight: number;
  rows: any[] = [];
  hoveredRow = 0;
  types = ['text', 'date', 'radio', 'file', 'textarea', 'dropdown'];
  formOptions!: any;
  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              public toastService: ToastMessagesService,
              private resumeService: ResumeService,
              public dialog: MatDialog) {
    this.pageWidth = window.innerWidth - 100;
    this.pageHeight = window.innerHeight - 100;
  }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(async (params) => {
      this.formOptions = {
        mode: params.mode,
        id: +params.id
      };
    });
    this.dynamicForm = this.formBuilder.group({
      title: this.formBuilder.control('', [Validators.required]),
      fields: this.formBuilder.array([])
    });
  }

  removeField(index: number) {
    const fields = this.dynamicForm.get('fields') as FormArray;
    fields.removeAt(index);
  }

  setHoveredRow(rowId: number) {
    this.hoveredRow = rowId;
  }

  onSubmit() {
    if (this.dynamicForm.invalid) {
      return;
    }

    // Access the form values and perform further actions
    console.log(this.dynamicForm.value);
  }

  shouldDisplay(id) {
    return this.hoveredRow === id;
  }
}
